import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyL } from '@sorare/core/src/atoms/typography';

import { BriefGame } from 'components/so5/BriefGame';

import { PlayerUpcomingGames_game } from './__generated__/index.graphql';

type Props = {
  games: (PlayerUpcomingGames_game | null)[];
};

export const PlayerUpcomingGames = ({ games }: Props) => {
  if (!games.length) {
    return null;
  }

  return (
    <Vertical>
      <BodyL bold>
        <FormattedMessage
          id="ComposeTeam.PlayerDetailsDialog.PlayerUpcomingGames.Title"
          defaultMessage="Upcoming games"
        />
      </BodyL>
      <Vertical gap={2}>
        {games.map(game => {
          if (!game) {
            return null;
          }

          return !!game && <BriefGame key={game.id} game={game} />;
        })}
      </Vertical>
    </Vertical>
  );
};

PlayerUpcomingGames.fragments = {
  game: gql`
    fragment PlayerUpcomingGames_game on Game {
      id
      date
      ...BriefGame_anyGameInterface
    }
    ${BriefGame.fragments.anyGameInterface}
  ` as TypedDocumentNode<PlayerUpcomingGames_game>,
};
